import { keepPreviousData } from '@tanstack/react-query';
import { getWfmLanding } from '../services/wfm-service';
import {
  STALE_SHORT_MS, denyOnForbidden, retryUnlessMissing, useWfmSnapshotQuery, wfmKeys,
} from './wfm-query';

const fetchLanding = denyOnForbidden(getWfmLanding);

export default function useWfmLanding({ month, enabled = true } = {}) {
  return useWfmSnapshotQuery({
    queryKey: wfmKeys.landing(month),
    queryFn: () => fetchLanding(month),
    enabled,
    placeholderData: keepPreviousData,
    staleTime: STALE_SHORT_MS,
    retry: retryUnlessMissing,
  });
}
